/**
 * `/poste/borne` — fiches filled on the borne or from its QR, waiting for the
 * desk (spec 2026-09-27 §5.2). A tab like the others; the chrome shows it
 * only when the org has a borne, and keeps polling and chiming from every tab.
 */
import { createFileRoute } from "@tanstack/react-router";

import { BorneInboxList } from "~/components/poste/borne-inbox";
import { StationChrome } from "~/components/station/station-chrome";
import { orpc } from "~/lib/orpc";

export const Route = createFileRoute("/poste/borne")({
  // `me` too: the take-over dialog reads it with `useSuspenseQuery`.
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(orpc.shift.current.queryOptions()),
      context.queryClient.ensureQueryData(orpc.me.get.queryOptions()),
    ]);
  },
  component: BornePage,
});

function BornePage() {
  return (
    <StationChrome>
      <BorneInboxList />
    </StationChrome>
  );
}
